import { render, staticRenderFns } from "./score-log.vue?vue&type=template&id=157e95b2&scoped=true"
import script from "./score-log.vue?vue&type=script&lang=js"
export * from "./score-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e95b2",
  null
  
)

export default component.exports